import styles from './style.module.scss';
import { Descriptions, Space, Spin, Col, Badge } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { DownloadOutlined } from '@ant-design/icons';
import { EditIcon } from 'icons';
import { useTranslation } from 'react-i18next';
import useDocuments from '../useInvoiceMonthlies';
import moment from 'moment';

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, handleDownloadPdf, statusTexts, statusColors } =
    useDocuments(false);

  const title = t('FATTURATI MENSILE');

  return singleItem ? (
    <div>
      <PageHeader title={title}>
        <Col>
          <Link to={'edit'}>
            <Button icon={<EditIcon />} type={'secondary'} big>
              {t('MODIFICA')}
            </Button>
          </Link>
        </Col>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Insegna')}>
            {singleItem.company?.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data caricamento')}>
            {singleItem?.file?.created_at
              ? moment(singleItem.file.created_at).format('DD/MM/YYYY HH:mm')
              : ''}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data del Fatturato')}>
            {singleItem.periodNormal
              ? moment(singleItem.periodNormal).format('MM/YYYY')
              : ''}
          </Descriptions.Item>
          <Descriptions.Item label={t('Stato')}>
            <Badge
              color={statusColors[singleItem.status]}
              text={statusTexts[singleItem.status]}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('File')}>
            <Space>
              <Button
                type={'primary-white'}
                icon={<DownloadOutlined />}
                onClick={() =>
                  handleDownloadPdf(
                    singleItem.file?.url,
                    singleItem.file?.file_name,
                  )
                }
              >
                Scarica file
              </Button>
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  ) : (
    <Spin size={'large'} />
  );
};

export default Single;
